"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const provider_1 = tslib_1.__importDefault(require("@json-rpc-tools/provider"));
const utils_1 = require("@json-rpc-tools/utils");
class ThreeIdProvider extends provider_1.default {
    get is3idProvider() {
        return true;
    }
    enable(authOpts) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.connection.connected) {
                    yield this.connect();
                }
                const request = utils_1.formatJsonRpcRequest('3id_authenticate', authOpts);
                const result = yield this.request(request);
                this.events.emit('enable');
                return result;
            }
            catch (err) {
                yield this.disconnect();
                throw err;
            }
        });
    }
}
exports.default = ThreeIdProvider;
//# sourceMappingURL=provider.js.map